import Loading from "../../assets/icons/Loading";
import { sendToken } from "./EmailVerification.tools";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import './EmailVerification.scss';

const EmailVerification = () => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    if (token)
      sendToken(token, navigate, setLoading);
  }, [navigate, searchParams]);

  return (
    <div id="email-verification">
      {loading ? (
        <div className="loading">
          <Loading />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default EmailVerification;
